import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CommonService} from '../../../core/service/common.service';
import {SessionService} from '../../../core/service/session.service';
import {EventService} from '../../../core/service/event.service';
import {ShiyoulotService} from '../../../core/service/shiyoulot.service';
import {DebeakEvent} from '../../interfaces/debeak-event';
import {exceptKeyWithOptional, yyyyMMdd} from '../../typeAliases';
import {AbstractEventJisshiNaiyou} from '../../interfaces/abstract-event-jisshi-naiyou';

@Component({
  selector: 'app-debeak-event-dialog',
  templateUrl: './debeak-event-dialog.component.html',
  styleUrls: ['./debeak-event-dialog.component.scss',
    './../../layout/layout.component.scss']
})
export class DebeakEventDialogComponent implements OnInit {
  selectedMeisais: DebeakEvent[] = [];
  inputForm: exceptKeyWithOptional<AbstractEventJisshiNaiyou, 'jisshiDate'> = this.eventService.getInitialAbstractEventJisshiNaiyou();
  editEvent = false;
  edukeDate: yyyyMMdd;
  constructor(@Inject(MAT_DIALOG_DATA) public data: DebeakEvent[],
              public matDialogRef: MatDialogRef<DebeakEventDialogComponent>,
              public commonService: CommonService,
              public sessionService: SessionService,
              public eventService: EventService,
              public shiyoulotService: ShiyoulotService,) {
    this.edukeDate = this.data[0].taishouEdukeDate;
  }

  /**
   *
   */
  ngOnInit(): void {
    this.selectedMeisais = this.data;
    this.eventService.setInputForm2(this.inputForm, this.selectedMeisais[0]);
    this.eventService.updateJisshiNichirei2(this.inputForm, this.edukeDate);
  }

  /**
   * デビークイベント登録
   */
  register() {
    this.selectedMeisais.forEach((meisai: DebeakEvent) => {
      this.eventService.inputForm2Event2(this.inputForm, meisai);
      console.log(meisai);
    });
    this.eventService.updateEvents(this.selectedMeisais).then(() => {
      // 成功した場合のみ true を返す
      this.commonService.onClick(this.matDialogRef, true);
    }).catch(e => {
      console.log('component promise all', e);
      alert(e);
    });
  }

  /**
   * デビークイベント取り消し
   */
  undo() {
    if (confirm('実施内容を取り消しますか?')) {
      this.eventService.undoEvents(this.selectedMeisais).then(() => {
        // 成功した場合のみ true を返す
        this.commonService.onClick(this.matDialogRef, true);
      }).catch();
    }
  }

  /**
   * デビークイベント削除
   */
  delete() {
    if (confirm('作業を削除しますか?')) {
      this.eventService.deleteEvents(this.selectedMeisais).then(() => {
        // 成功した場合のみ true を返す
        this.commonService.onClick(this.matDialogRef, true);
      }).catch();
    }
  }
}
